import { HTTP } from './helpers/http.js'

export default {
  getById(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions/${revId}`
    return HTTP.get(url)
  },
}
